import React, { useEffect, useState } from 'react';
import { deepClone } from '../../../utils/helpers';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { sections, TherapistPracticeAddress, ServicesContent2,  TherapistSelections } from '../../../latest/src/containers/TherapistProfile/Tabs';
import Content from './Content';
import Content2 from './Content2';
import TherapistAvailabilityWidgetMain from 'src/latest/src/components/TherapistAvailabilityWidget/TherapistAvailabilityWidgetMain';
import { useParams } from 'react-router-dom';
import { useIsMobile } from "src/latest/src/hooks";
import { BioSection } from 'src/latest/src/containers/TherapistProfile/Components/BioSection';
import "../therapist-profile.scss";
import { MeetingPreferences } from 'src/containers/TherapistClientProfile/Tabs/profile';
import { TherapistLanguages } from 'src/latest/src/containers/TherapistProfile/Components/TherapistLanguages';
import { Typography } from "src/latest/src/components";
type Props = {
    showPage: any,
    selectedUserContext: any,
};

export default function ProfileScreen({
    showPage,
    selectedUserContext,
}: Props): React$Element<any> {
    const { profileId } = useParams();
    const isFromMobile = useIsMobile();
    const [licenseTypeInfo, setLicenseTypeInfo] = useState({});
    const [preLicenseTypeInfo, setPreLicenseTypeInfo] = useState({});
    const [educationalInfo, setEducationalInfo] = useState({});
    const [yearsInPractice, setYearsInPractice] = useState(0);
    const [degreeType, setDegreeType] = useState("");
    const pageMetadata = useSelector(
        (state) => state?.questionnaireData?.questionnairePageData
    );
    const [allPages, setAllPages] = useState([]);
    const { loggedInUser } = useSelector((state) => state?.authentication);
    const [mergedData, setMergedData] = useState();
    const [mergedApproachesData, setMergedApproachesData] = useState();
    const isStaffProfile = !selectedUserContext?.user_type?.includes("THERAPIST");
    const practicelogo = useSelector((state) => state?.questionnaireData?.clientMetaData?.metadata?.tenant_logo);
    const showAvailibilityWidget =
        selectedUserContext?.user_type?.includes("THERAPIST") &&
        (!loggedInUser?.id || loggedInUser?.user_type?.includes("CLIENT"));

    function calculateAllPages(pageMetadata) {
        let pushedArr = [];

        // changed .map() to .forEach() below to remove the eslint warnings.
        deepClone(pageMetadata)?.questionnaire_group?.categories?.forEach(
            (category, index) => {
                category?.pages.map((p) => {
                    p.sequence = index * 1000 + p.sequence;
                    pushedArr.push(p);

                    return p;
                });
            }
        );

        pushedArr = pushedArr?.sort(function(a, b) {
            return a.sequence - b.sequence;
        });

        setAllPages(pushedArr);
    }

    useEffect(() => {
        calculateAllPages(pageMetadata);
    }, [pageMetadata]);

    const getSectionData = (identifier: string) => {
        if (allPages && allPages?.length !== 0) {
            return allPages?.filter(
                (page) => page?.frontend_identifier === identifier
            )[0];
        }
    };

    // Here we get the therapist Certificates
    const getTheraPistCertificates = (pages) => {
        const page = pages?.filter(
            (page) =>
                page?.frontend_identifier ===
                sections?.certificationSection?.pageIdentifier
        )[0];
        const question = page?.questions?.filter(
            (question) =>
                question?.frontend_identifier ===
                sections?.certificationSection?.questionIdentifier[0]
        )[0];

        return question?.choices?.filter((choice) => choice.value);
    };

    // Here we are creating license type info object
    const getLicenseTypeInfo = () => {
        const page = allPages?.filter(
            (page) =>
                page?.frontend_identifier ===
                sections?.certificationSection?.pageIdentifier
        )[0];
        const licenseInfo = {};

        // changed .map() to .forEach() below to remove the eslint warnings.
        page?.questions?.forEach((question) => {
            if (
                question.frontend_identifier ===
                "licensednumberTherapistQuestion"
            ) {
                licenseInfo.number = getLicenseValues(question?.choices).filter(
                    (value) => value
                )[0];
            }

            if (
                question.frontend_identifier ===
                "licensedprovidertypeTherapistQuestion"
            ) {
                licenseInfo.type = getLicenseValues(question?.choices).filter(
                    (value) => value
                )[0];
            }

            if (
                question.frontend_identifier ===
                "licensedstateTherapistQuestion"
            ) {
                licenseInfo.state = getLicenseValues(question?.choices).filter(
                    (value) => value
                )[0];
            }
        });
        setLicenseTypeInfo(licenseInfo);
    };

    // Here we are creating prelicense type info object
    const getPreLicenseTypeInfo = () => {
        const page = allPages?.filter(
            (page) =>
                page.frontend_identifier ===
                sections.certificationSection?.pageIdentifier
        )[0];
        const preLicenseInfo = {};

        // changed .map() to .forEach() below to remove the eslint warnings.
        page?.questions?.forEach((question) => {
            if (
                question.frontend_identifier ===
                "prelicensednumberTherapistQuestion"
            ) {
                preLicenseInfo.number = getLicenseValues(
                    question?.choices
                ).filter((value) => value)[0];
            }

            if (
                question.frontend_identifier ===
                "prelicensedprovidertypeTherapistQuestion"
            ) {
                preLicenseInfo.type = getLicenseValues(
                    question?.choices
                ).filter((value) => value)[0];
            }

            if (
                question.frontend_identifier ===
                "prelicensedstateTherapistQuestion"
            ) {
                preLicenseInfo.state = getLicenseValues(
                    question?.choices
                ).filter((value) => value)[0];
            }

            if (
                question.frontend_identifier ===
                "supervisornameTherapistQuestion"
            ) {
                preLicenseInfo.supervisorName = getLicenseValues(
                    question?.choices
                ).filter((value) => value)[0];
            }

            if (
                question.frontend_identifier ===
                "supervisorlicensedstateTherapistQuestion"
            ) {
                preLicenseInfo.supervisorState = getLicenseValues(
                    question?.choices
                ).filter((value) => value)[0];
            }

            if (
                question.frontend_identifier ===
                "supervisorlicensednumberTherapistQuestion"
            ) {
                preLicenseInfo.supervisorLiecensNumber = getLicenseValues(
                    question?.choices
                ).filter((value) => value)[0];
            }
        });
        setPreLicenseTypeInfo(preLicenseInfo);
    };

    // Here we get the selected choice and their value
    const getLicenseValues = (choices) => {
        return choices?.filter((choice) => choice.selected && choice.value)?.map((choice) => choice.value); 
    };


    // Get Degree Type
    const getDegreeType = () => {
        const page = allPages?.filter(
            (page) =>
                page.frontend_identifier ===
                sections.typeOfDegree?.pageIdentifier
        )[0];

        const questions = page?.questions?.filter(
            (page) =>
                page.frontend_identifier ===
                sections.typeOfDegree?.questionIdentifier[0]
        )[0];

        setDegreeType(getLicenseValues(questions?.choices)?.[0]);
    };

    // Here we are creating educational info object
    const getEducationalInfo = () => {
        const page = allPages?.filter(
            (page) =>
                page.frontend_identifier ===
                sections.educationalSection?.pageIdentifier
        )[0];
        const educational = {};

        // changed .map() to .forEach() below to remove the eslint warnings.
        page?.questions?.forEach((question) => {
            if (
                question.frontend_identifier ===
                "schoolgraduatedTherapistQuestion"
            ) {
                educational.schoolName = getLicenseValues(
                    question?.choices
                ).filter((value) => value)[0];
            }

            if (
                question.frontend_identifier ===
                "yeargraduatedTherapistQuestion"
            ) {
                educational.yearOfGraduation = getLicenseValues(
                    question?.choices
                ).filter((value) => value)[0];
            }
        });
        setEducationalInfo(educational);
    };

    // Here we calculate the years in practice
    const getYearsInPractice = () => {
        const page = allPages?.filter(
            (page) =>
                page.frontend_identifier ===
                sections.educationalSection?.pageIdentifier
        )[0];

        // changed .map() to .forEach() below to remove the eslint warnings.
        page?.questions?.forEach((question) => {
            if (
                question.frontend_identifier ===
                "yearbeginpracticeTherapistQuestion"
            ) {
                setYearsInPractice(
                    new Date().getFullYear() -
                    +getLicenseValues(question?.choices).filter(
                        (value) => value
                    )[0]
                );
            }
        });
    };

    const combinedSections = [
        sections.therapyTopThreeConcerns.pageIdentifier,
        sections.therapyTopSevenConcerns.pageIdentifier,
        sections.therapistConcerns.pageIdentifier,
    ];
    const combineApproachesSections = [
        sections.primaryTherapistModalities.pageIdentifier,
        sections.secondaryTherapistModalities.pageIdentifier,
        sections.tertiaryTherapistModalities.pageIdentifier
    ];

    useEffect(() => {
        if (allPages?.length) {
            const _combinedSectionData = combinedSections.map((section) => {
                return getSectionData(section);
            });
            const _mergedData = mergeAllSectionsData(_combinedSectionData);

            setMergedData(_mergedData);
        }
    }, [allPages]);

    function mergeAllSectionsData(data) {
        let mergedData = [];
        let dataArray = [];

        data.forEach((dataObj) => {
            switch (dataObj?.frontend_identifier) {
                case "topThreeExpertiseTherapistpageFI":
                    dataArray = dataObj?.questions[0]?.choices;
                    break;
                case "topSevenExpertiseTherapistpageFI":
                    dataArray = dataObj?.questions[0]?.choices;
                    break;
                case "otherExpertiseTherapistpageFI":
                    // for all expertise we need to pick the selected ones only
                    // so we needed to add the filter for that
                    dataObj?.questions.forEach(question => {
                        if (question?.choices?.length) {
                            const selectedChoices = question?.choices.filter((choice) => choice.selected === true);

                            dataArray.push(...selectedChoices);
                        }
                    });
                    break;
                default:
                    break;
            }

            // this code is to combine the data but keeping only the unique choices
            const mergedArray = mergedData.concat(dataArray.filter(item2 =>
                !mergedData.some(item1 => item1?.id === item2?.id)
            ));

            mergedData = mergedArray;
        });

        return mergedData;
    }

    useEffect(() => {
        if (allPages?.length) {
            const _combinedApproachesSectionData = combineApproachesSections.map((Approachessection) => {
                return getSectionData(Approachessection);
            });
            const _mergedApproachesData = mergeAllApproachesSectionsData(_combinedApproachesSectionData);

            setMergedApproachesData(_mergedApproachesData);
        }
    }, [allPages]);

    function mergeAllApproachesSectionsData(data) {
        let mergedApproachesData = [];
        let dataApproachesArray = [];

        data.forEach((dataObj) => {

            switch (dataObj?.frontend_identifier) {
                case "primaryModalitiesTherapistPage":
                    dataApproachesArray = dataObj?.questions[0]?.choices;
                    break;
                case "topThreeModalitiesTherapistPage":
                    dataApproachesArray = dataObj?.questions[0]?.choices;
                    break;
                case "tertiaryModalitiesTherapistPage":
                    // for all expertise we need to pick the selected ones only
                    // so we needed to add the filter for that
                    dataObj?.questions.forEach(question => {
                        if (question?.choices?.length) {
                            const selectedApprochesChoices = question?.choices.filter((choice) => choice.selected === true);

                            dataApproachesArray.push(...selectedApprochesChoices);
                        }
                    });
                    break;
                default:
                    break;
            }

            const mergedApproachesArray = mergedApproachesData.concat(dataApproachesArray.filter(item2 =>
                !mergedApproachesData.some(item1 => item1?.id === item2?.id)
            ));

            mergedApproachesData = mergedApproachesArray;
        });

        return mergedApproachesData;
    }

    const inPersonOfficeAddresses = getSectionData(
        sections.therapyPracticeAddress
            .pageIdentifier
    );
    const selectedInPersonOfficeAddress = inPersonOfficeAddresses?.questions[0]?.choices?.filter((choice)=>choice?.selected === true);

    useEffect(() => {
        if (allPages) {
            getDegreeType();
            getYearsInPractice();
            getEducationalInfo();
            getLicenseTypeInfo();
            getPreLicenseTypeInfo();
        }
    }, [allPages]);



    return (
        <div>
            {!allPages || allPages.length === 0 ? (
                <div className="th-profile-loader">
                    <Spinner animation="border" role="status" />
                </div>
            ) : (
                <div className="therapist-profile__section">
                    <div className="therapist-profile__section__wrapper">

                        {/* services section  */}
                        {!isStaffProfile && (
                            <div className="therapist-profile__container therapist-profile__flex">
                                <ServicesContent2
                                    section={getSectionData(
                                        sections.serviceProvided.pageIdentifier
                                    )}
                                    showPage={showPage}
                                />
                            </div>
                        )}

                        {/* cash pay and insurance section */}
                        {!isStaffProfile && (
                            <div className="therapist-profile__container insurance-section">
                                {
                                    <Content2
                                        value={getSectionData(sections.paymentSection.pageIdentifier)}
                                        secKey={"paymentSection"}
                                        showPage={showPage}
                                    />
                                }
                            </div>
                        )}

                        {/* bio section for scheduler and pa-admin  */}
                        {isStaffProfile && (
                            <div className="therapist-profile__container bio-section container-with-view-element">
                                <BioSection
                                    value={getSectionData(
                                        sections.bioScheduler.pageIdentifier
                                    )}
                                    secKey={"bioScheduler"}
                                    showPage={showPage}
                                />
                                <BioSection
                                    value={getSectionData(
                                        sections.bioPracticeAdmin.pageIdentifier
                                    )}
                                    secKey={"bioPracticeAdmin"}
                                    showPage={showPage}
                                />
                            </div>
                        )}
                        {/* bio section for therapist  */}
                        {!isStaffProfile && (
                            <div className="therapist-profile__container bio-section container-with-view-element">
                                <BioSection
                                    value={getSectionData(
                                        sections.bio.pageIdentifier
                                    )}
                                    secKey={"bioSection"}
                                    showPage={showPage}
                                />
                            </div>
                        )}

                        {/* therapist concerns section  */}
                        <div className="therapist-profile__container">
                            {!isStaffProfile && (
                                <TherapistSelections
                                    value={getSectionData(sections.therapistConcerns.pageIdentifier)}
                                    mergedData={mergedData}
                                    label={"EXPERTISE"}
                                    showPage={showPage}
                                />
                            )}
                        </div>

                        {/* therapist approaches section  */}
                        {mergedApproachesData && mergedApproachesData.length > 0 &&
                            <div className="therapist-profile__container">
                                {!isStaffProfile && (
                                    <TherapistSelections
                                        value={getSectionData(sections.tertiaryTherapistModalities.pageIdentifier)}
                                        mergedData={mergedApproachesData}
                                        label={"APPROACHES"}
                                        alignHorizontal={true}
                                        showPage={showPage}
                                    />
                                )}
                            </div>
                        }

                        {/* age group section  */}
                        {!isStaffProfile && (
                            <div className="therapist-profile__container">
                                <Content2
                                    value={getSectionData(sections.clientAgeGroup.pageIdentifier)}
                                    secKey={"clientAgeGroup"}
                                    alignVertical={false}
                                    isDisplayTitle={true}
                                    clientAgeGroup={true}
                                    showPage={showPage}
                                />
                            </div>
                        )}

                            {/* language section  */}
                            <div className="therapist-profile__container">
                                {!isStaffProfile && (
                                    <TherapistLanguages
                                        section={getSectionData(sections.languagePage.pageIdentifier)}
                                        sectionData={getSectionData(
                                            sections.therapyLanguagePage
                                                .pageIdentifier
                                        )}
                                        secKey={"languagePage"}
                                        showPage={showPage}
                                    />
                                )}

                                {isStaffProfile && (
                                    <TherapistLanguages
                                        section={getSectionData(
                                            sections.basicSchedulerLanguage
                                                .pageIdentifier
                                        )}
                                        secKey={"basicSchedulerLanguage"}
                                        showPage={showPage}
                                    />
                                )}

                                {isStaffProfile && (
                                    <TherapistLanguages
                                        section={getSectionData(
                                            sections.basicPracticeAdminLanguage
                                                .pageIdentifier
                                        )}
                                        secKey={"basicPracticeAdminLanguage"}
                                        showPage={showPage}
                                    />
                                )}
                            </div>

                        {/* practice info  */}
                            <>
                                {isFromMobile ? <>
                                    {practicelogo && (
                                        <div className="therapist-profile__container">
                                            <div className="sub-section width-half">
                                                <Typography
                                                    variant="size-14"
                                                    weight="bold"
                                                    color="color-28"
                                                >
                                                    PRACTICE
                                                </Typography>
                                                <div className="mt-3">
                                                    <img
                                                        src={`${decodeURIComponent(
                                                            practicelogo
                                                        )}`}
                                                        alt="practice logo"
                                                        className="tenant_logo"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="therapist-profile__container">
                                            <Content
                                                title="MEETING PREFERENCES"
                                                value={``}
                                                showPage={showPage}
                                                section={getSectionData(
                                                    sections.meetingPreferences
                                                        .pageIdentifier
                                                )}
                                            />
                                            <MeetingPreferences
                                                section={getSectionData(
                                                    sections.meetingPreferences
                                                        .pageIdentifier
                                                )}
                                            />
                                    </div>

                                    <div className="therapist-profile__container">
                                        <TherapistPracticeAddress
                                            title="IN-PERSON OFFICE"
                                            section={getSectionData(
                                                sections.therapyPracticeAddress
                                                    .pageIdentifier
                                            )}
                                        />
                                    </div>

                                </> :
                                    <div className="therapist-profile__container">
                                        <Content
                                            value={
                                            <div className="d-flex">
                                                {practicelogo && (
                                                    <div className="sub-section width-half">
                                                        <Typography
                                                            variant="size-14"
                                                            weight="bold"
                                                            color="color-28"
                                                        >
                                                            PRACTICE
                                                        </Typography>
                                                        <div className="mt-3">
                                                            <img
                                                                src={`${decodeURIComponent(
                                                                    practicelogo
                                                                )}`}
                                                                alt="practice logo"
                                                                className="tenant_logo"
                                                            />
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="sub-section width-half">
                                                    <Typography
                                                            variant="size-14"
                                                            weight="bold"
                                                            color="color-28"
                                                        >
                                                            MEETING PREFERENCES
                                                    </Typography>
                                                    <MeetingPreferences
                                                        section={getSectionData(
                                                            sections.meetingPreferences
                                                                .pageIdentifier
                                                        )}
                                                    />
                                                </div>

                                                    {selectedInPersonOfficeAddress?.length > 0 && (
                                                        <div className="sub-section width-half">
                                                            <TherapistPracticeAddress
                                                                title="IN-PERSON OFFICE"
                                                                section={inPersonOfficeAddresses}
                                                            />
                                                        </div>
                                                    )}
                                            </div>}
                                            isRemoveTitle={true}
                                            showPage={showPage}
                                            section={getSectionData(
                                                sections.meetingPreferences
                                                    .pageIdentifier
                                            )}
                                        />
                                    </div>
                                }
                            </>

                        {/* license information section  */}
                        {/* license Type */}
                        {!isStaffProfile &&
                            licenseTypeInfo.type &&
                            licenseTypeInfo.state &&
                            licenseTypeInfo.number && (
                                <div className="therapist-profile__container">
                                    <Content
                                        title="LICENSE TYPE"
                                        value={
                                            <React.Fragment>
                                                <Typography
                                                    variant="size-16"
                                                    weight="semi-bold"
                                                    color="color-2"
                                                >
                                                    {licenseTypeInfo.type}
                                                </Typography>
                                                <Typography
                                                    variant="size-16"
                                                    weight="regular"
                                                    color="color-2"
                                                >
                                                    {licenseTypeInfo.state} |{" "}
                                                    {licenseTypeInfo.number}
                                                </Typography>
                                            </React.Fragment>
                                        }
                                        showPage={showPage}
                                        section={getSectionData(
                                            sections.licenseTypeSection
                                                .pageIdentifier
                                        )}
                                    />
                                </div>
                            )}

                        {/* preliecens type  */}
                        {!isStaffProfile &&
                            preLicenseTypeInfo.type &&
                            preLicenseTypeInfo.state &&
                            preLicenseTypeInfo.number && (
                                <div className="therapist-profile__container">
                                    <Content
                                        title="LICENSE TYPE"
                                        value={
                                            <React.Fragment>
                                                <Typography
                                                    variant="size-16"
                                                    weight="semi-bold"
                                                    color="color-2"
                                                >
                                                    {preLicenseTypeInfo.type}
                                                </Typography>
                                                <Typography
                                                    variant="size-16"
                                                    weight="regular"
                                                    color="color-2"
                                                >
                                                    {preLicenseTypeInfo.state} |{" "}
                                                    {preLicenseTypeInfo.number}
                                                </Typography>
                                                <Typography
                                                    variant="size-16"
                                                    weight="semi-bold"
                                                    color="color-2"
                                                    className="mt-3"
                                                >
                                                    Supervisor Details
                                                </Typography>
                                                <Typography
                                                    variant="size-16"
                                                    weight="regular"
                                                    color="color-2"
                                                >
                                                    {
                                                        preLicenseTypeInfo.supervisorState
                                                    }{" "}
                                                    |{" "}
                                                    {
                                                        preLicenseTypeInfo.supervisorLiecensNumber
                                                    }
                                                </Typography>
                                            </React.Fragment>
                                        }
                                        showPage={showPage}
                                        section={getSectionData(
                                            sections.licenseTypeSection
                                                .pageIdentifier
                                        )}
                                    />
                                </div>
                            )}

                        {/* school, graduation and certification info section  */}
                        {!isStaffProfile &&
                            (educationalInfo?.schoolName !== undefined ||
                                educationalInfo?.yearOfGraduation !==
                                undefined) && (
                                <div className="therapist-profile__container therapist-profile__flex">
                                    <Content
                                        sectionClassName="sub-section-2x"
                                        title="SCHOOL AND YEAR GRADUATED"
                                        value={
                                            <React.Fragment>
                                                <div className='d-flex school-name-section'>
                                                    <div className='school-name'>
                                                        <Typography
                                                            variant="size-16"
                                                            weight="semi-bold"
                                                            color="color-2"
                                                        >
                                                            {
                                                                educationalInfo?.schoolName
                                                            }
                                                        </Typography>
                                                    </div>
                                                    &nbsp; | &nbsp;
                                                    <div>
                                                        <Typography
                                                            variant="size-16"
                                                            weight="regular"
                                                            color="color-2"
                                                        >
                                                            {
                                                                educationalInfo?.yearOfGraduation
                                                            }
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        }
                                        classname="alignment"
                                        section={getSectionData(
                                            sections.typeOfDegree.pageIdentifier
                                        )}
                                        secKey={"typeOfDegree"}
                                        showPage={showPage}
                                    />
                                    <Content
                                        sectionClassName="sub-section-2x"
                                        title="TYPE OF DEGREE"
                                        value={
                                            <React.Fragment>
                                                <div className='degree-type-section'>
                                                    <Typography
                                                        variant="size-16"
                                                        weight="semi-bold"
                                                        color="color-2"
                                                    >
                                                        {degreeType}
                                                    </Typography>
                                                </div>
                                            </React.Fragment>
                                        }
                                        section={getSectionData(
                                            sections.typeOfDegree.pageIdentifier
                                        )}
                                        secKey={"typeOfDegree"}
                                        showPage={showPage}
                                    />
                                    {!isNaN(yearsInPractice) && yearsInPractice !== null && yearsInPractice !== undefined && (
                                        <Content
                                            sectionClassName="sub-section-1x"
                                            title="YEAR IN PRACTICE"
                                            value={
                                                <React.Fragment>
                                                    <Typography
                                                        variant="size-16"
                                                        weight="semi-bold"
                                                        color="color-2"
                                                    >
                                                        {yearsInPractice}{" "}
                                                        {yearsInPractice === 0 ? "" : "year"}
                                                        {yearsInPractice > 1 ? "s" : ""}
                                                    </Typography>
                                                </React.Fragment>
                                            }
                                            section={getSectionData(
                                                sections.typeOfDegree.pageIdentifier
                                            )}
                                            secKey={"typeOfDegree"}
                                            showPage={showPage}
                                        />
                                    )}

                                </div>
                            )}

                            {!isStaffProfile && (
                                <div className="therapist-profile__container">
                                    <TherapistSelections
                                        value={getSectionData(sections.certificationSection.pageIdentifier)}
                                        mergedData={getTheraPistCertificates(
                                            allPages
                                        )}
                                        label={"Other Credentials & Certifications"}
                                        showPage={showPage}
                                    />
                                </div>
                            )}
                            
                    </div>

                    {showAvailibilityWidget && !isFromMobile && (
                        <div className="therapist-profile__section__wrapper therapist-profile__section__availibility-widget">
                            <TherapistAvailabilityWidgetMain
                             profileId={profileId && profileId}
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}